export default interface NetProtocol{
    code:number;
    data?:any;
    msg:string;
    token:string;
}

export class LoginProto{
    public account:string="";
    public password:string="";
    public loginty:number=0;
}

export class LoginByTonken{
    public account:string="";
    public token:string="";
}

export class RefreshToken{
    public account:string="";
}

export class RegisterProto{
    public account:string="";
    public password:string="";
    public verifycode:string="";
}

export class VerifyCode{
    public account:string="";
    public actype:number=0;
}

export class ReSetPsdProto{
    public account:string="";
    public password:string="";
    public verifycode:string="";
}

export class ChangePsdProto{
    public account:string="";
    public oldpassword:string="";
    public newpassword:string="";
}

export class Address{
    public fullname:string;
    public areacode:string;
    public phonenum:string;
    public country:string;
    public address:string;
    public postcodes:string;
}

export class product{
    public orderid:string;
    public account:string;
    public details:string;
    public captureid:string;
    public price:number;
    public state:number;
    public timed:number;
    public shopcart:cartdata[];
    public trackingnum:string;
    public address:Address;
}

export class cartdata{
    ProductId:string="";
    Names:string="";
    Price:number=0;
    ImgeId:number=0;
    Amount:number=0;
}

export class UserData{
    public account:string;
    public password:string;
    public actype:number;
    public products:number[];
    public shopcart:cartdata[];
    public address:Address[];
}

export class UserAddress{
    public account:string;
    public address:Address;
    public tyindex:number; // 地址索引，-1添加新地址，否则修改索引地址
}

// 删除地址
export class DelUserAddress{
    public account:string;
    public tyindex:number; // 地址索引，-1添加新地址，否则修改索引地址
}

export class GetUserAddress{
    public account:string;
    public useract:string;
}

export class CPaypalTokenProto{
    public account:string;
}

export class SPaypalTokenProto{
    public paypaltoken:string;
    public expires_in:number;
}
// 支付
export class PayPalPayProto{
    public account:string="";
    public description:string="";
    public price:number=0;
    public discount:number=0;
    public items:cartdata[]=[];
    public address:Address;
}

export class PayPalCaptureProto{
    public account:string="";
    public orderid:string="";
}
// 取消订单
export class PayPalCancelProto{
    public account:string;
    public orderid:string;
}
// 添加运单号信息
export class PayPalAddTrackingProto{
    public account:string;
    public orderid:string;
    public timed:number;
    public tracking_number:string;
    public carrier:string;
}
// 购物车
export class ShopCartProto{
    public account:string;
    public shopcart:cartdata[];
}
// 获取订单信息
export class CGetOrthersProto{
    public account:string;
    public timeds:number[];
}
// 获取订单信息返回
export class SGetOrthersProto{
    public orthers:product[];
}
// 删除订单
export class CDelOrthersProto{
    public account:string;
    public timeds:number[];
}
// 删除订单返回
export class SDelOrthersProto{
    public timeds:number[];
}

// 更新订单地址
export class CUpDataAddress{
    public account:string;
    public timed:number;
    public address:Address;
}
// 获取时间段内所有订单
export class ServerOrdersProto{
    public account:string;
    public starttime: number;
    public endtime:number;
}

// 更新订单状态
export class ServerOrderStatusProto{
    public account:string;
    public timed:number;
    public status:number;
}

export class CSetCertificate{
    public account:string;
    public certype:number;//1 cer证书, 2 chain 证书链 3 private私钥
    public cerdata:string;
}